export default __webpack_public_path__ + "static/media/pronunciation-guide.27b37fbc.pdf";